<template>
    <div>
        <gofix-card :title="item.set_name" fullContent class="propertyInventoryCard" collapse>
            <template slot="gofixCard:after_title" v-if="this.item.inventory_parent">
                <span class="desc">Inherited From {{this.item.property_name}}</span>
            </template>
            <template slot="gofixCard:right_header">
                <div class="d-flex justify-content-end align-items-center">
                    <span v-if="!item.inventory_parent" @click="deleteSet(item)" class="search pull-right cursor-pointer">
                        <img width="20" height="20" src="img/deleteIcon.png" alt="delete"/>
                    </span>
                </div>
            </template>
            <div class="gofixBasicTable">
                <div v-if="!this.item.inventory_parent" class="actionList mb-3">
                    <div class="list innerControl">
                        <span @click="reloadInventory" class="mr-3" v-b-tooltip.hover title="Refresh">
                            <img src="img/reLoad.png" alt="reload"/>
                        </span>
                        <span @click="openModalCreate" class="mr-3" v-b-tooltip.hover title="Create">
                            <img src="img/blankIcon.png" alt="blank"/>
                        </span>
                        <span v-if="selected.length > 0" @click="openModalDelete" v-b-tooltip.hover title="Delete">
                            <img src="img/deleteIcon.png" alt="delete"/>
                        </span>
                    </div>
                </div>
                <div class="dataList">
                    <b-table v-if="!collapsed" fixed @row-clicked="editItem" table-class="tableList" :responsive="true" style="padding-bottom: 10px" class="animated fadeIn gofixTables" :items="this.item.room_inventories" :fields="fields.fields">
                        <template slot="HEAD_actions" slot-scope="foo">
                            <b-form-checkbox class="uniform" @input="toggleSelected" v-model="allSelected"></b-form-checkbox>
                        </template>
                        <template slot="actions" slot-scope="row">
                            <b-form-checkbox :value="row.item.id" v-model="selected"></b-form-checkbox>
                        </template>
                        <template slot="replacement_cost" slot-scope="row">
                            {{ row.item.replacement_cost | formatMoney}}
                        </template>
                        <template slot="room_category" slot-scope="row">
                            {{ item.room_category_name}}
                        </template>
                        <template slot="location_type" slot-scope="row">
                            {{ item.location_type_name}}
                        </template>
                    </b-table>
                </div>
            </div>
        </gofix-card>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" ref="modal-Remove">
            <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="$bvModal.hide('modal-Remove')">No
                </b-button>
                <b-button class="custom-btn" @click="deleteData(item)" :disabled="isAction"><b-spinner v-if="isAction" type="grow" small></b-spinner>Yes</b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="models.title" hide-footer :centered="true" v-model="models.open"  refs="modal-Create">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="3">
                        <div class="label_title mb-2"> Location Type: </div>
                    </b-col>
                    <b-col md="9" class="label_item">{{this.item.location_type_name }}</b-col>
                </b-row>
                <b-row>
                    <b-col md="3">
                        <div class="label_title mb-2"> Category: </div>
                    </b-col>
                    <b-col md="9" class="label_item">
                        {{this.item.room_category_name}}
                    </b-col>
                </b-row>
                <gofix-form-input label="Item Name" v-model="models.data.item_name"></gofix-form-input>
                <gofix-form-input-number
                    label="Replacement Cost"
                    v-model="models.data.replacement_cost"
                    class="pb-20"
                    prefix="$">
                </gofix-form-input-number>
                <b-row>
                    <b-col md="6">
                        <gofix-form-input-number
                            label="Quantity"
                            v-model="models.data.quantity"
                            :include-thousands-separator="false"></gofix-form-input-number>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input label="UOM" v-model="models.data.unit_of_measurement"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="CANCEL" @click="models.open = false" noBorder dark></gofix-button>
                <gofix-button label="OK" @click="createItem" :loading="models.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: 'room_inventory',
        components: {},
        props: {
            deleteSet: {
                type: Function
            },
            reloadInventory: {
                type: Function
            },
            item: {
                type: Object
            },
            fields: {
                type: Object
            }
        },
        watch: {
            selected: function(val) {
                if(this.item.room_inventories.length > val.length) {
                    this.allSelected = false
                    return
                }
                if(val.length > 0 && this.item.room_inventories.length == val.length) {
                    this.allSelected = true
                }
            }
        },
        methods: {
            toggle_collapsed(){
                this.collapsed = !this.collapsed;
            },
            toggleSelected(val) {
                if (this.allSelected) {
                    this.selected = [];
                    for (let i in this.item.room_inventories) {
                        this.selected.push(this.item.room_inventories[i].id)
                    }
                    return
                }
                if(!this.allSelected && this.item.room_inventories.length == this.selected.length) {
                    this.selected = []
                }
            },
            editItem(item){
                // Do not allow editing of the inherited inventory set
                if(this.item.inventory_parent){
                  return
                }
                this.models.title = "Edit Item";
                this.models.open = true;
                this.models.data = {
                    id: item.id,
                    item_name: item.item_name,
                    quantity: item.quantity + "",
                    replacement_cost: item.replacement_cost !== 0 ? this.$accounting.formatMoney(item.replacement_cost): '',
                    unit_of_measurement: item.unit_of_measurement

                }
            },
            createItem(){
                // Do not allow editing of the inherited inventory set
                if(this.item.inventory_parent){
                  return
                }
                if(this.models.data.id){
                    let params = {
                        id: this.models.data.id,
                        property_id: this.item.property_id,
                        location_type_id: this.item.location_type_id,
                        room_category_id: this.item.room_category_id,
                        item_name: this.models.data.item_name,
                        quantity: this.models.data.quantity,
                        replacement_cost: this.models.data.replacement_cost ? this.$accounting.unformat(this.models.data.replacement_cost) : 0,
                        unit_of_measurement: this.models.data.unit_of_measurement
                    }

                    this.$store.dispatch("PropertyController/updateRoomInventory", params)
                        .then(response => {
                            this.models.open = false
                            this.reloadInventory();
                            this.$alertNotification(this.$notificationV2('editing', 'room_inventory'));
                        })
                        
                    return
                }
                let params = {
                    room_inventory_set_id: this.item.id,
                    property_id: this.item.property_id,
                    location_type_id: this.item.location_type_id,
                    room_category_id: this.item.room_category_id,
                    item_name: this.models.data.item_name,
                    quantity: this.models.data.quantity,
                    replacement_cost: this.models.data.replacement_cost ? this.$accounting.unformat(this.models.data.replacement_cost) : 0,
                    unit_of_measurement: this.models.data.unit_of_measurement,
                    sn:(this.item.room_inventories.length + 1)
                }
                this.$store.dispatch("PropertyController/createRoomInventory", params)
                    .then(response => {
                        this.models.open = false
                        this.reloadInventory();
                        this.$alertNotification(this.$notificationV2('adding', 'room_inventory'));
                    })
            },
            openModalCreate(){
                this.models.open = true;
                this.models.title = "Add New Item";
                this.models.data  = {
                    id: null,
                    item_name: null,
                    quantity: null,
                    replacement_cost: null,
                    unit_of_measurement: null
                }
            },
            openModalDelete(){
                this.$refs['modal-Remove'].show();
            },
            deleteData(item) {
                let params = {
                    ids: this.selected,
                    room_inventory_set_id : item.id
                }
                this.isAction = true;
                this.$store.dispatch(`PropertyController/deleteRoomInventory`, params)
                    .then(response => {
                        this.selected = []
                        this.allSelected = false
                        this.isAction = false;
                        this.$refs['modal-Remove'].hide();
                        this.reloadInventory();
                        this.$alertNotification(this.$notificationV2('deleting', 'room_inventory'));
                    })
            }
        },
        data () {
            return {
                collapsed: false,
                selected: [],
                allSelected: false,
                isAction: false,
                selected: [],
                activeClass: false,
                models: {
                    open: false,
                    title:"Add New Item ",
                    data:{
                        id: null,
                        item_name: null,
                        quantity: null,
                        replacement_cost: this.$accounting.formatMoney(0),
                        unit_of_measurement: null
                    },
                },
            }
        }
    }
</script>
